module.exports = __webpack_public_path__ + "app/community/list-referentials-community-2RDc2VLf.html";